export default __webpack_public_path__ + "static/media/24.ea6f591c.jpg";